import styled from "styled-components";

export const TableSection = styled.div`
	width: 100%;
	min-height: 188px;
`;

export const StyledTableWrapper = styled.div`
	width: 100%;
	overflow: hidden;
	border-radius: 14px;
	border: 1px solid rgba(110, 113, 145, 0.12);
	background: rgba(0, 0, 0, 0.08);

	.limits-period-active {
		color: var(--main-color);
		font-weight: 700;
	}

	.ant-table {
		background: transparent;
		color: var(--content-text-color);
		width: 100%;
	}

	.ant-table-thead > tr > th {
		background: rgba(110, 113, 145, 0.12) !important;
		color: var(--secondary-text-color) !important;
		font-size: 10px;
		font-weight: 700;
		text-transform: uppercase;
		letter-spacing: 0.5px;
		border-bottom: 1px solid rgba(110, 113, 145, 0.2) !important;
		padding: 10px 14px !important;
		white-space: nowrap;
	}

	.ant-table-tbody > tr > td {
		background: transparent;
		color: var(--content-text-color);
		font-size: 12px;
		border-bottom: 1px solid rgba(110, 113, 145, 0.1) !important;
		padding: 10px 14px !important;
		vertical-align: middle;
	}

	.ant-table-tbody > tr.limits-row-selected > td {
		background: var(--main-explosive-opacity-05, rgba(110, 113, 145, 0.08)) !important;
	}

	.ant-table-tbody > tr:last-child > td {
		border-bottom: none !important;
	}
`;

export const UsageCell = styled.div`
	width: 100%;
	max-width: 96px;
`;

export const ProgressTrack = styled.div`
	width: 100%;
	height: 6px;
	border-radius: 999px;
	background: rgba(110, 113, 145, 0.2);
	overflow: hidden;
`;

export const ProgressFill = styled.div`
	height: 100%;
	border-radius: inherit;
	background: var(--main-color);
	width: ${({ $percent }) => $percent || 0}%;
`;
